import { useState } from "react";
import { template as tmpl } from "./template";
import _ from "lodash";
import { requestOTPResetPassword } from "@/stores/apis/apiAuth";
import { REGEX_EMAIL } from "@/config/constants";

const SendCode = ({ onSendCodeSuccess }) => {
	const [loading, setLoading] = useState(false);
	const [errors, setErrors] = useState({});
	const [type, setType] = useState("email"); // email or sms
	const [email, setEmail] = useState("");
	const [phone, setPhone] = useState("");

	const onFinish = async () => {
		if (loading) return;

		let payload = {
			method: type,
		};

		if (type === "email") {
			if (!email || !REGEX_EMAIL.test(email)) {
				setErrors({ email: "Invalid email" });
				setLoading(false);
				return;
			}

			payload.email = email;
		} else if (type === "sms") {
			if (!phone) {
				setErrors({ phone: "Invalid phone" });
				setLoading(false);
				return;
			}

			payload.phone = phone;
		}

		// open loading
		setLoading(true);

		let result = await requestOTPResetPassword(payload);
		if (result && result.success) {
			onSendCodeSuccess && onSendCodeSuccess(payload);
		} else if (result && result.error) {
			try {
				if (type === "email") {
					setErrors({ email: result.error?.message });
				} else {
					setErrors({ phone: result.error?.message });
				}
			} catch (e) {
				//
			}
		}

		setTimeout(() => {
			setLoading(false);
		}, 350);
	};

	const onChangeTab = (key) => {
		setType(key);
	};

	const initProps = {
		loading: loading,
		email: email,
		setEmail: setEmail,
		errors: errors,
		setErrors,
		onFinish: onFinish,
		phone: phone,
		setPhone: setPhone,
		type: type,
		onChangeTab: onChangeTab,
	};
	return tmpl && tmpl({ ...initProps });
};

export default SendCode;
